import { SpecialEventValueTypes } from "../SpecialEventsQuery/SpecialEventsQuery.consts";

export const PatientAttributeOptions = {
  AGE_GROUP: "AGE_GROUP_TYPE",
  NEW_PATIENT_IDENTIFIED: "NEW_PATIENT_IDENTIFIED",
  PATIENT_TYPE: "PATIENT_TYPE"
};

export const PatientAttributes = {
  [PatientAttributeOptions.AGE_GROUP]: {
    type: PatientAttributeOptions.AGE_GROUP,
    key: "ageGroup",
    label: "Age group",
    valueType: SpecialEventValueTypes.DROPDOWN,
    placeholder: "Select age group"
  },
  [PatientAttributeOptions.NEW_PATIENT_IDENTIFIED]: {
    type: PatientAttributeOptions.NEW_PATIENT_IDENTIFIED,
    label: "New patient identified",
    valueType: SpecialEventValueTypes.BOOLEAN_INCLUDED
  },
  [PatientAttributeOptions.PATIENT_TYPE]: {
    type: PatientAttributeOptions.PATIENT_TYPE,
    key: "type",
    label: "Clinic affiliation",
    valueType: SpecialEventValueTypes.DROPDOWN,
    placeholder: "Select clinic affiliation"
  }
};
